// @flow
import 'common/helpers/polyfill';
import EnvConfig from 'config';

window.mfeEndPoints = EnvConfig.mfeEndPoints;

import('./bootstrap');
